import ChatIcon from '../../../assets/icons/ChatIcon.svg?react';

const chatLinkClasses =
    "appearance-none bg-transparent border-0 text-primary font-semibold text-sm " +
    "inline-flex items-center gap-1.5 cursor-pointer py-0.5 px-0 " +
    "hover:underline disabled:opacity-50 disabled:cursor-not-allowed";

const SubmitChatButton = ({ onClick, disabled }) => {
    return (
        <button
            type="button"
            className={chatLinkClasses}
            onClick={onClick}
            disabled={disabled}
        >
            Chat
            <ChatIcon />
        </button>
    );
};

export default SubmitChatButton;
